import type { TVariant } from "~/components/ui/ProductHeader/_data/types"

export function getVariantMinPrice(variants: TVariant[]) {
  const minPriceAmount = Math.min(...variants.map((variant) => variant.price?.amount).filter(Boolean))

  return variants.find((variant) => variant.price?.amount === minPriceAmount) ?? null
}
